import {
  faChevronDown,
  faCircleExclamation,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from '@redux';
import crudActions from '@redux/crudActions';
import { Button, Dropdown, MenuProps, Modal, Space } from 'antd';
import { useRestContext } from 'components/form/RestInputContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DynamicObjectType } from 'types/commons';

export default function EditActions({
  model,
  id,
  options,
  customSubmit,
  customUrlBack,
  saveButtonLabel,
  isOpenModal = false,
  titleModal,
  descriptionModal,
}: {
  model: string;
  id?: string;
  options?: React.ReactNode[];
  onSelect?: (value) => void;
  customSubmit?: (form) => void;
  customUrlBack?: string;
  saveButtonLabel?: string;
  isOpenModal?: boolean;
  titleModal?: string;
  descriptionModal?: string;
}) {
  const { t } = useTranslation();
  const { form } = useRestContext();
  const dispatch = useDispatch();
  const loading = useSelector<boolean>(
    (state) => state[model].itemLoadings[id],
  );
  const navigate = useNavigate();
  const onCancel = () => {
    if (customUrlBack) {
      navigate(customUrlBack);
    } else {
      navigate(-1);
    }
  };

  const items: MenuProps['items'] = options?.map((item, index) => ({
    key: index,
    label: item,
  }));

  const openModal = () => {
    dispatch(
      crudActions.modal.toogleModal({
        ['confirm']: {
          isOpen: true,
        },
      } as any),
    );
  };

  return (
    <>
      <Space>
        <Button
          disabled={loading}
          onClick={onCancel}
          className="btn-light btn-h-32"
        >
          Cancel
        </Button>
        <Button
          loading={loading}
          onClick={
            isOpenModal
              ? () => openModal()
              : customSubmit
                ? () => customSubmit(form)
                : () => form.submit()
          }
          type="primary"
          className="btn-h-32"
        >
          {saveButtonLabel || 'Save'}
        </Button>
        {options?.length > 0 && (
          <Dropdown overlayClassName="edit-options" menu={{ items }}>
            <Button className="btn-h-32">
              {t('button.select')}
              <FontAwesomeIcon
                icon={faChevronDown}
                className="text-gray-second-color text-sm ml-[5px]"
              />
            </Button>
          </Dropdown>
        )}
      </Space>
      <ConfirmModal
        onSubmit={customSubmit ? () => customSubmit(form) : () => form.submit()}
        loading={loading}
        titleModal={titleModal}
        descriptionModal={descriptionModal}
      />
    </>
  );
}

export const ConfirmModal = ({
  onSubmit,
  loading,
  titleModal,
  descriptionModal,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const modal = useSelector<DynamicObjectType>((state) => state.modal.modal);
  const onCancel = () => {
    dispatch(
      crudActions.modal.toogleModal({
        ['confirm']: {
          isOpen: false,
        },
      } as any),
    );
  };

  return (
    <Modal
      open={modal?.confirm?.isOpen}
      onCancel={onCancel}
      footer={null}
      width={443}
      closeIcon={false}
      closable={false}
    >
      <div className="grid gap-5">
        <div className="text-center text-[24px]">
          <FontAwesomeIcon
            icon={faCircleExclamation}
            className="text-[--primary] mb-[5px]"
          />
          <div className="text-center text-base font-semibold">
            {t(titleModal || 'transferOrders.confirmAction')}
          </div>
        </div>
        <div className="text-center text-[#53575D] text-sm">
          {t(descriptionModal || 'transferOrders.confirmActionDescription')}
        </div>
        <div className="flex justify-center items-center gap-2.5">
          <Button className="h-[40px] w-[100px]" onClick={onCancel}>
            {t('button.cancel')}
          </Button>
          <Button
            className="h-[40px] w-[100px]"
            type="primary"
            onClick={onSubmit}
            loading={loading}
          >
            {t('button.ok')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
